import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import CSSMotion from 'rc-motion';
import PanelContent from './PanelContent';

const CollapsePanel = props => {
  const {
    className,
    showArrow = true,
    isActive = false,
    headerClass,
    forceRender = false,
    prefixCls,
    collapsible,
    style,
    id,
    children,
    header,
    expandIcon,
    openMotion,
    destroyInactivePanel,
    accordion,
    ghost
  } = props;

  const itemRef = useRef(null);
  // useEffect(() => {
  //   console.log(111);
  //   itemRef.current.scrollIntoView({ behavior: 'smooth' });
  // }, isActive);
  const handleItemClick = () => {
    const { onItemClick = () => {}, panelKey } = props;
    if (typeof onItemClick === 'function') {
      onItemClick(panelKey);
    }
  };

  const disabled = collapsible === 'disable';

  const itemCls = classNames({
    [`${prefixCls}-item`]: true,
    [`${prefixCls}-item-active`]: isActive,
    [`${prefixCls}-item-disabled`]: disabled,
    [`${prefixCls}-item-ghost`]: ghost,
    className
  });

  const headerCls = classNames(`${prefixCls}-header`, {
    [headerClass]: headerClass
  });

  let icon = (
    <i
      className="arrow"
      onClick={collapsible === 'icon' && handleItemClick()}
    ></i>
  );
  if (showArrow && typeof expandIcon === 'function') {
    icon = expandIcon(props);
  }
  return (
    <div className={itemCls} style={style} id={id} ref={itemRef}>
      <div
        className={headerCls}
        onClick={() => !collapsible && handleItemClick()}
      >
        {showArrow && icon}
        {collapsible === 'header' ? (
          <span
            onClick={handleItemClick}
            className={`${prefixCls}-header-text`}
          >
            {header}
          </span>
        ) : (
          header
        )}
      </div>
      <CSSMotion
        visible={isActive}
        leavedClassName={`${prefixCls}-content-hidden`}
        {...openMotion}
        forceRender={forceRender}
        removeOnLeave={destroyInactivePanel}
      >
        {({ className: motionClassName, style: motionStyle }, ref) => {
          return (
            <PanelContent
              ref={ref}
              prefixCls={prefixCls}
              className={motionClassName}
              style={motionStyle}
              isActive={isActive}
              forceRender={forceRender}
              role={accordion ? 'tabpanel' : null}
            >
              {children}
            </PanelContent>
          );
        }}
      </CSSMotion>
    </div>
  );
};

export default CollapsePanel;
